import React, {useEffect, useState} from 'react'
import { Dropdown, Grid, Input, Button, Icon } from 'semantic-ui-react'
import {useForm, Controller} from "react-hook-form"
import TwilioData from "../Sections/TwilioData"
import './style.css'

const TWILIO_WEBHOOK = "https://api.axc.ae/webhook/b1acf1f9-ffab-4131-9379-7bfb7cea29fe";

const DEFAULT_TWILIO_FORM_VALUES = {
    code: '',
    responsible: '',
    Ad_Project: '',
    Ad_Language: '',
    source_detail: '',
    marker: '',
    tags: []
}

const Twillio = () => {
    const {
        control,
        handleSubmit,
        reset
    } = useForm({
        defaultValues: DEFAULT_TWILIO_FORM_VALUES
    })

    const [projects, setProject] = useState([])
    const [language, setLanguage] = useState([])
    const [responsible, setresponsible] = useState([])
    const [tags, setTags] = useState([])
    const [responseMessage, setResponseMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const normalizeWebhookRows = (payload) => {
        let parsedPayload = payload;

        if (typeof parsedPayload === 'string') {
            try {
                parsedPayload = JSON.parse(parsedPayload);
            } catch (error) {
                return [];
            }
        }

        const candidates = [
            parsedPayload,
            parsedPayload?.body,
            parsedPayload?.data,
            parsedPayload?.rows,
            parsedPayload?.result,
            parsedPayload?.items,
            parsedPayload?.json,
            parsedPayload?.[0]?.json,
            parsedPayload?.[0]?.body,
            parsedPayload?.[0]?.data
        ];

        const rows = candidates.find(candidate => Array.isArray(candidate));

        return Array.isArray(rows)
            ? rows
                .map(row => row?.json || row?.body || row)
                .filter(row => row && Object.keys(row).length > 0)
            : [];
    }

    const readWebhookResponse = async (response) => {
        const text = await response.text();

        if (!text) {
            return {message: 'done'};
        }

        return JSON.parse(text);
    }

    async function adProject(){
        const response = await fetch('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1568907438');
        const data = await response.json();
        setProject(data.result[0].LIST)
    }
    async function adLang(){
        const response = await fetch('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1553165368131');
        const data = await response.json();
        setLanguage(data.result[0].LIST)
    }
    
    async function adResponsible(){
        const response = await fetch('https://crm.axcap.ae/local/webhooks/getUserIdName.php?api_key=UPmcMSpk86SLPprv');
        const data = await response.json();
        setresponsible(data)
    }

    async function adTags(){
        let start = 0;
        let allTags = [];

        while (start !== null) {
            const response = await fetch(`https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/lists.element.get?IBLOCK_TYPE_ID=lists&IBLOCK_ID=189&ELEMENT_ORDER%5BID%5D=ASC&start=${start}`);
            const data = await response.json();

            allTags = allTags.concat(data.result || []);
            start = data.next ?? null;
        }

        setTags(allTags)
    }

    useEffect(() => {
        adProject();
        adLang();
        adResponsible();
        adTags();
    }, [])
    const transformProject = projects.map(project => ({
        key: project.ID,
        text: project.VALUE,
        value: project.ID
    }))
    const transformLanguage = language.map(language => ({
        key: language.ID,
        text: language.VALUE,
        value: language.ID
    }))
    
    const transformResponsible = responsible.map(responsible => ({
        key: responsible.ID,
        text: responsible.NAME,
        value: responsible.ID
    }))
    const transformTags = tags.map(tag => ({
        key: tag.ID,
        text: tag.NAME,
        value: tag.ID
    }))
    transformResponsible.push({key: 1, text: 'AX CAPITAL', value: '1'})

    const onSubmit = async (fields) => {
        if (isSubmitting) {
            return;
        }

        if (!fields.code?.toString().trim()) {
            setResponseMessage({message: 'Campaign Code is required'});
            return;
        }

        setIsSubmitting(true);
        setResponseMessage('');

            try {
                const duplicateResponse = await fetch(TWILIO_WEBHOOK, {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify({
                        source: "twilio",
                        action: "checkDuplicate",
                        fields: {
                            code: fields.code
                        }
                    })
                });
                const duplicateData = await readWebhookResponse(duplicateResponse);
                const duplicates = normalizeWebhookRows(duplicateData);

                if (duplicates.length > 0) {
                    setResponseMessage({message: `Duplicate code. Existing ID: ${duplicates[0].id}`});
                    return;
                }

                const response = await fetch(TWILIO_WEBHOOK, {
                    method: 'POST',
                    mode: 'cors', 
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify({
                        source: "twilio",
                        action: "create",
                        fields
                    }) 
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
        
                const data = await readWebhookResponse(response); // Получаем тело ответа в формате JSON
                setResponseMessage(data); 

                reset(DEFAULT_TWILIO_FORM_VALUES);
                setRefreshKey(prevKey => prevKey + 1);
            } catch (error) {
                console.error('Error:', error);
                setResponseMessage('An error occurred'); // Сообщение в случае ошибки
            } finally {
                setIsSubmitting(false);
            }
        
    }

    
    return(
        <>
            <h1 className='title'>- Twillio -</h1>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container columns='equal' className='grid-form'>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Campaign Code
                                </span>
                                <Controller
                                    name='code'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input type='text' placeholder='Insert...' {...field}/>}
                                />
                                
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Responsible
                                </span>
                                <Controller
                                    name='responsible'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='select responsible'
                                            fluid
                                            search
                                            selection
                                            options={transformResponsible}
                                            value={value}
                                            // defaultValue="1"
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Project
                                </span>
                                <Controller
                                    name='Ad_Project'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Project'
                                            fluid
                                            search
                                            selection
                                            options={transformProject}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                        <div className='item'>
                                <span>
                                    Language
                                </span>
                                <Controller
                                    name='Ad_Language'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Language'
                                            fluid
                                            search
                                            selection
                                            options={transformLanguage}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Source Details
                                </span>
                                <Controller
                                    name='source_detail'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                        <div className='item'>
                                <span>
                                    Marker:
                                </span>
                                <Controller
                                    name='marker'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Tags
                                </span>
                                <Controller
                                    name='tags'
                                    defaultValue={[]}
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Tags'
                                            fluid
                                            multiple
                                            search
                                            selection
                                            options={transformTags}
                                            value={value}
                                            onOpen={adTags}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                        </Grid.Column>
                    </Grid.Row>
                    <Button animated className='fb-button' type='submit' disabled={isSubmitting} loading={isSubmitting}>
                        <Button.Content visible>Create Integration</Button.Content>
                        <Button.Content hidden>
                            <Icon name='arrow right' />
                        </Button.Content>
                    </Button>
                </Grid>
            </form>
            {responseMessage && (
                <div className='reponse-message'>
                    <p>Response: {responseMessage.message} | ID: {responseMessage.id}</p>
                </div>
            )}
            <TwilioData refreshKey={refreshKey}/>
        </>
    )
}

export default Twillio;
